import { Box, Button, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import calendar from '../../assets/icons/calendar_orange.svg'
import ModalReplyMessage from 'components/modal/coordinate/ModalReplyMessage';
import * as api from '../services/api'
import Loader from 'components/Loader';

function DetailsCoordinate() {
    const navigate = useNavigate()
    const location = useLocation()
    const [loading, setLoading] = useState(false)
    const [openModal, setOpenModal] = useState(false)
    const [contactCode, setContactCode] = useState(location.state.code)
    const [coordinate, setCoordinate] = useState([])

    useEffect(() => {
        let code_ = location.state.code
        // setContactCode(code_)
        console.log(code_)

        findContacts()
    }, [])

    const convertDate = (dataDate) => {
        const date = new Date(dataDate)
        const optionDate = {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
        }
        const thaiLocale = 'th-TH'
        const formattedDate = date.toLocaleString(thaiLocale, optionDate)
        const newDate = `${formattedDate}`

        return newDate
    }
    const convertToThaiDateTime = (utcDateStr) => {
        const date = new Date(utcDateStr)
        // เวลาไทย (UTC+7)
        const options = {
            timeZone: 'Asia/Bangkok',
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            hour12: false,
        }
        const thaiDate = new Intl.DateTimeFormat('th-TH', options).formatToParts(date)

        const day = thaiDate.find(i => i.type === 'day').value
        const month = thaiDate.find(i => i.type === 'month').value
        const yearBE = parseInt(thaiDate.find(i => i.type === 'year').value) // ปี พ.ศ.
        const hour = thaiDate.find(i => i.type === 'hour').value
        const minute = thaiDate.find(i => i.type === 'minute').value

        return `${day}/${month}/${yearBE} ${hour}:${minute}`
    }

    const handleReplyMessage = () => {
        setOpenModal(true)
    }

    const findContacts = async () => {
        setLoading(true)
        let res = await api.contacts(null, contactCode)
        setLoading(false)
        if (res) {
            if (res['data']['code'] === 200) {
                setCoordinate(res['data']['data'][0])
            } else {
                //alert(res['data']['message'])
            }
        } else {
            alert('ไม่ตอบสนอง')
        }
    }

    return (
        <>
            {openModal &&
                <ModalReplyMessage
                    onClose={() => { setOpenModal(false) }}
                    contactCode={contactCode}
                    onRefresh={() => { findContacts() }}
                />
            }
            <Loader loading={loading} />
            <Box sx={{ display: 'grid', gridGap: '10px' }}>
                <Box sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gridGap: '10px'
                }}>
                    <KeyboardBackspaceIcon sx={{ fontSize: '20px' }} />
                    <Box sx={{
                        cursor: 'pointer'
                    }}
                        onClick={() => { navigate('/community') }}
                    >กลับไป ติดต่อประสานงาน</Box>
                </Box>

                <Box sx={{
                    fontWeight: 600,
                    color: "#478F96",
                    "@media (max-width: 800px)": {
                        textAlign: "center",
                    },
                }}>{coordinate['contact_topic']}</Box>

                <Box sx={{ display: 'flex', gridGap: '10px' }}>
                    <img src={calendar} />
                    <Box>สร้างเมื่อ {convertDate(coordinate['created_date'])}</Box>
                </Box>

                <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                    <img style={{ borderRadius: '10px', width: '60%' }} src={coordinate['contact_image_url']} />
                </Box>

                <Box>{coordinate['contact_detail']}</Box>

                <Box sx={{ textAlign: 'end' }}>
                    <Button variant='contained' onClick={() => { handleReplyMessage() }}>ตอบกลับ</Button>
                </Box>

                {coordinate['message_list']?.map((item, index) => (
                    <Box sx={{
                        border: '1px solid #478F96',
                        borderRadius: '10px',
                        padding: '20px',
                        display: 'grid',
                        gridGap: '10px'
                    }} key={index}>
                        <Box sx={{ display: 'grid', gridTemplateColumns: '50px 11fr', gridGap: '10px' }}>
                            <Box>
                                <img src={item['answer_image_url']} style={{ width: '100%', borderRadius: '50%' }} />
                            </Box>
                            <Box>
                                <Box sx={{ fontWeight: 600 }}>{item['answer_name']}</Box>
                                <Box sx={{ color: '#90A0B7', fontSize: '14px' }}>{item['department_name_short']}</Box>
                            </Box>
                        </Box>
                        <Box>{item['message']}</Box>
                        <Box>
                            <Typography sx={{ fontWeight: 600 }}>ไฟล์แนบ:</Typography>
                            <Box sx={{ display: 'grid', gridGap: '10px' }}>
                                {item['message_attachment_file']?.map((i, idx) => (
                                    <Box key={idx}>
                                        {i['url'] &&
                                            <Box sx={{
                                                border: '1px solid #AEB4DD',
                                                borderRadius: '10px',
                                                padding: '10px 30px',
                                                textDecoration: 'underline',
                                                display: 'flex'
                                            }}
                                                onClick={() => { window.open(i['url'], '_blank') }}
                                            >
                                                <Typography sx={{ cursor: 'pointer' }}>{i['filename']}</Typography>
                                            </Box>
                                        }
                                    </Box>
                                ))}
                            </Box>
                        </Box>
                        <Box>ตอบกลับเมื่อ {convertToThaiDateTime(item['answer_date'])}</Box>
                    </Box>
                ))}

            </Box>
        </>
    )
}

export default DetailsCoordinate
